import { settings } from "app";
import React from "react";
import { ArrayField, Datagrid, FunctionField, NumberField } from "react-admin";
import { EnrollmentStatesTexts } from "utils/constants";
import { Grid, Typography, useMediaQuery } from "@mui/material";

const CoursesSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Grid
      container
      spacing={3}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <Typography
          color={"#4E2683"}
          fontWeight={600}
        >
          Избрани курсове
        </Typography>
        <ArrayField source="courses">
          <Datagrid
            rowClick={false}
            bulkActionButtons={false}
            sx={settings.style.secondaryDatagrid}
          >
            <NumberField
              label="ID"
              source="courseId"
            />
            <NumberField
              label="Курс по"
              source="name"
            />
            <FunctionField
              label="Статус"
              render={rec => EnrollmentStatesTexts[rec.state] || "-"}
            />
          </Datagrid>
        </ArrayField>
      </Grid>
    </Grid>
  );
};

export default CoursesSection;
